import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Edit18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_571)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.625 1.10732L10.4763 3.25607C10.474 3.25822 10.4718 3.26039 10.4697 3.26257C10.4675 3.26476 10.4653 3.26695 10.4632 3.26916L1.96968 11.7626C1.87356 11.8587 1.80537 11.9791 1.7724 12.111L0.772402 16.111C0.637558 16.6504 1.14253 17.1554 1.68191 17.0205L5.68191 16.0205C5.81378 15.9876 5.93422 15.9194 6.03034 15.8233L16.6804 5.17328L16.6856 5.16793C17.1555 4.68851 17.1556 3.89733 16.6856 3.4179L14.3804 1.11257L14.375 1.10732C13.8956 0.637384 13.1044 0.637384 12.625 1.10732ZM11 4.85358L3.17723 12.6764L2.53079 15.2621L5.11657 14.6157L12.9394 6.79292L11 4.85358ZM14 5.73226L15.4393 4.29293L13.5 2.35359L12.0607 3.79292L14 5.73226Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_571'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Edit18.displayName = 'Edit18';
export default Edit18;
